'use strict';
// globals
module.exports={
};



// WEBPACK FOOTER //
// ./application/src/models/globals.js